module.exports = _CONFIG_;